import { render, staticRenderFns } from "./orderMenuAdd.vue?vue&type=template&id=6b4786f3&scoped=true&"
import script from "./orderMenuAdd.vue?vue&type=script&lang=js&"
export * from "./orderMenuAdd.vue?vue&type=script&lang=js&"
import style0 from "./orderMenuAdd.vue?vue&type=style&index=0&id=6b4786f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4786f3",
  null
  
)

export default component.exports